import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';

import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { TranslateService } from '@ngx-translate/core';
import { DialogService } from 'primeng/dynamicdialog';

import { collectUuidNameMap, isScopeValueUsedInRolesError } from '@app/auth/interceptors/scope-value-used-in-roles.utils';
import { CommonScopeValueUsedInRolesDialogComponent } from '@app/common-modules/common-scope-value-used-in-roles-dialog/common-scope-value-used-in-roles-dialog.component';

export const scopeValueUsedInRolesInterceptor: HttpInterceptorFn = (request: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const dialogService = inject(DialogService);
  const translateService = inject(TranslateService);

  return next(request).pipe(
    catchError(err => {
      if (isScopeValueUsedInRolesError(err)) {
        dialogService.open(CommonScopeValueUsedInRolesDialogComponent, {
          header: translateService.instant('fe.globals.errors.scope_value_used_in_roles.title'),
          closable: true,
          draggable: false,
          width: '28rem',
          inputValues: {
            items: err.error.data,
            names: collectUuidNameMap(request.body),
          },
        });
      }
      return throwError(() => err);
    }),
  );
};
